import React, { Component } from "react";

import ManageMerchantGatewayRates from "./ManageMerchantGatewayRates";
import ManageNewMerchantRates from "./ManageNewMerchantRates";
import ManageNewStripeRates from "./ManageNewStripeRates";

import Util from "../../../../libs/util";

import data from "currency-codes/data";

class ManageMerchantRatesv2 extends Component {
	constructor(props) {
		super(props);

		const priorityCode = ["SGD", "MYR", "USD"];
		const codes = [
			...data.filter((i) => priorityCode.includes(i.code)),
			...data.filter((i) => !priorityCode.includes(i.code)),
		];

		this.state = {
			currency: [
				...codes.map((d) => {
					return { name: d.code, value: d.number };
				}),
			],
			newRateConfig: null,
		};
	}

	componentDidMount() {
		console.log("baseRate: ", this.props.baseRate);
	}

	openModal = (gateway, availableCurrency) => {
		this.setState({ newRateConfig: { gateway, availableCurrency } });
		Util.showModal("manage-new-rates");
	};

	openStripeModal = () => {
		Util.showModal("manage-new-stripe-rates");
	};

	checkEnableAdd = (availableCurrency) => {
		if (!this.props.master) return false;
		if (availableCurrency.length === 0) return false;
		return true;
	};

	checkCurrency = (gateway) => {
		if (gateway === "stripe") return [];

		const { currency } = this.state;
		let targetRates = this.props.rates[gateway];
		if (targetRates) {
			let addedCurrency = Object.keys(targetRates);
			return currency.filter((i) => !addedCurrency.includes(String(i.value)));
		} else {
			return currency;
		}
	};

	render() {
		const {
			merchant,
			MDRTypes,
			gateway: gateways,
			rates,
			baseRate,
			retrieveMerchants,
			readOnly,
		} = this.props;
		const { newRateConfig } = this.state;

		let active = Object.keys(rates).length > 0 ? Object.keys(rates)[0] : "tctp";

		return (
			<>
				<ManageNewMerchantRates
					merchant={merchant}
					MDRTypes={MDRTypes}
					config={newRateConfig}
					baseRate={baseRate}
					retrieveMerchants={retrieveMerchants}
				/>
				{baseRate.stripe && (
					<ManageNewStripeRates
						merchant={merchant}
						MDRTypes={MDRTypes}
						gateway="stripe"
						baseRate={baseRate.stripe}
						retrieveMerchants={retrieveMerchants}
					/>
				)}
				<ul uk-tab="connect: #manage-transaction-rates">
					{Object.keys(gateways).map((gateway) => {
						if (!baseRate[gateway]) return;

						const availableCurrency = this.checkCurrency(gateway);
						const enableAdd = this.checkEnableAdd(availableCurrency);

						return (
							<li
								key={`manage-${gateway}-rates-tab`}
								className={gateway === active ? "uk-active" : ""}
							>
								<a className="transaction-gateway-tab">
									<img
										className="uk-img"
										src={`data:image/*;base64,${gateways[gateway].image}`}
										width="50"
									/>
									{enableAdd && (
										<button
											className="uk-margin-left uk-icon-button uk-button-primary"
											uk-icon="icon: fa-solid-plus-circle; ratio: 0.5"
											type="button"
											onClick={() =>
												gateway !== "stripe"
													? this.openModal(gateway, availableCurrency)
													: this.openStripeModal()
											}
										/>
									)}
								</a>
							</li>
						);
					})}
				</ul>
				<ul
					id="manage-transaction-rates"
					className="uk-switcher uk-margin-bottom"
				>
					{Object.keys(gateways).map((gateway, index) => {
						if (!baseRate[gateway]) return;
						return (
							<ManageMerchantGatewayRates
								key={index}
								merchant={merchant}
								MDRTypes={MDRTypes}
								baseRate={baseRate}
								rates={rates}
								gateway={gateway}
								retrieveMerchants={retrieveMerchants}
								readOnly={readOnly}
							/>
						);
					})}
				</ul>
			</>
		);
	}
}

export default ManageMerchantRatesv2;
